import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import * as models from 'src/app/business/chat/interface';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private user: Observable<firebase.User>;
    private authState: any;


    constructor(private afAuth: AngularFireAuth,
    ) {
        this.user = afAuth.authState;
    }

    signIn(token: string) {
        return this.afAuth.auth.signInWithCustomToken(token)
            .then((user) => {
                this.authState = user;
            }).catch(error => {console.log(error)});
    }

}
